import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

const useShowBulkImport = (importId, options = {}) => {
	const { accessToken } = useTokenStore();
	const { refetchInterval, enabled = true } = options;

	return useQuery(
		["bulkBookImport", importId],
		async () => {
			const instance = await InitApi({ accessToken });
			const response = await instance.get(
				`/publisher/bulk-book-imports/${importId}`
			);
			return response.data?.data;
		},
		{
			enabled: Boolean(importId) && enabled,
			refetchInterval: refetchInterval || false,
			refetchOnWindowFocus: true,
		}
	);
};

export default useShowBulkImport;
